import {Routes} from '@angular/router';

export const CommonLayout_ROUTES: Routes = [

  // Dashboard
  {
    path: 'dashboard',
    loadChildren: () => import('../../modules/dashboard/dashboard.module').then(m => m.DashboardModule),
  },
  {
    path: 'roboF',
    data: { title: 'Robo F'},
    loadChildren: () => import('../../modules/roboF/roboF.module').then(m => m.RoboFModule)
  },
  {
    path: 'smart-portfolio',
    data: { title: 'Smart Portfolio'},
    loadChildren: () => import('../../modules/smart-portfolio/smart-portfolio.module').then(m => m.SmartPortfolioModule)
  },
  {
    path: 'data-AI',
    data: { title: 'AI Knowledge Base'},
    loadChildren: () => import('../../modules/data-AI/data-AI.module').then(m => m.DataAIModule)
  },
];
